import InfiniteScrollSentinel from "../components/InfiniteScrollSentinel";
import ProductCard from "../components/ProductCard";
import ProductGridSkeleton from "../components/ProductGridSkeleton";
import StoreHeader from "../components/StoreHeader";
import { useInfiniteCatalog } from "../hooks/useInfiniteCatalog";

export default function StorefrontPage({ storeSlug }) {
  const {
    store,
    products,
    pagination,
    loading,
    loadingMore,
    error,
    hasMore,
    loadMore,
    retry,
  } = useInfiniteCatalog(storeSlug);

  const showBlockingError = error && products.length === 0 && !loading;

  return (
    <div className="storefront">
      <StoreHeader store={store} storeSlug={storeSlug} />

      <main className="catalog">
        <div className="catalog__heading">
          <div>
            <p className="catalog__eyebrow">Catálogo</p>
            <h2>Todos os produtos</h2>
          </div>
          {pagination && (
            <p className="catalog__count">
              {pagination.total}{" "}
              {pagination.total === 1 ? "produto" : "produtos"}
            </p>
          )}
        </div>

        {loading ? (
          <ProductGridSkeleton />
        ) : showBlockingError ? (
          <section className="state-card" role="alert">
            <h2>
              {error.status === 404
                ? "Loja não encontrada"
                : "Não foi possível abrir a loja"}
            </h2>
            <p>
              {error.status === 404
                ? "Confira o endereço ou aguarde até que a loja seja publicada."
                : error.message}
            </p>
            <button type="button" onClick={retry}>
              Tentar novamente
            </button>
          </section>
        ) : products.length === 0 ? (
          <section className="state-card">
            <h2>Nenhum produto disponível</h2>
            <p>Esta loja ainda não publicou produtos para venda.</p>
          </section>
        ) : (
          <>
            <div className="product-grid">
              {products.map((product) => (
                <ProductCard
                  product={product}
                  storeSlug={storeSlug}
                  key={product.id}
                />
              ))}
            </div>

            {error && (
              <div className="inline-error" role="alert">
                <span>Não foi possível carregar mais produtos.</span>
                <button type="button" onClick={retry}>
                  Tentar novamente
                </button>
              </div>
            )}

            {loadingMore && (
              <div className="loading-more" role="status">
                <span className="spinner" />
                Carregando mais produtos...
              </div>
            )}

            <InfiniteScrollSentinel
              enabled={hasMore}
              loading={loadingMore}
              onVisible={loadMore}
            />

            {!hasMore && products.length > 0 && (
              <p className="catalog__end">Você viu todos os produtos.</p>
            )}
          </>
        )}
      </main>

      <footer className="store-footer">
        <span>Loja criada com</span>
        <strong>AtomicPay</strong>
      </footer>
    </div>
  );
}
